module.exports = __webpack_public_path__ + "img/Brazil.85e5c527.svg";